import {
  PRODUCTS_LIST, PRODUCTS_LIST_SUCCESS, PRODUCTS_LIST_ERROR,
} from '../contants';
import { Product } from '../../models/product/product-response.model';

export const getProducts = (assignorGuid: string, productCategory: number = 0) => ({
  type: PRODUCTS_LIST,
  payload: { assignorGuid, productCategory },
});

export const getProductsSuccess = (products: Product[]) => ({
  type: PRODUCTS_LIST_SUCCESS,
  payload: products,
});
export const getProductsError = (message: any) => ({
  type: PRODUCTS_LIST_ERROR,
  payload: { message },
});
